import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { getIntegralExchange, getIntegralRule as _getIntegralRule } from '@/services/http';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import IntegralRule from '@/components/rule/integralRule.vue';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.loading = false; // 加载
    _this.integralExchange = []; // 积分商品列表
    _this.isLoading = false; // 表格加载
    _this.ruleList = []; // 积分规则列表
    _this.totalnumber = 0; // 总条数
    _this.pageNo = 1; // 当前页
    _this.pageSize = 12; // 当前条数
    _this.showRule = false; // 是否显示规则说明
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.setUserInfoList();
      this.getIntegralExchangeExchange(); // 积分兑换列表
      this.getIntegralRule(); // 积分规则列表
    }
    // 积分规则列表
  }, {
    key: "getIntegralRule",
    value: function () {
      var _getIntegralRule2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getIntegralRule({
                companyId: 1
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                this.ruleList = res.data.data.ruleList;
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getIntegralRule() {
        return _getIntegralRule2.apply(this, arguments);
      }
      return getIntegralRule;
    }() // 条数回调
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getIntegralExchangeExchange();
    }
    // 页数回调
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getIntegralExchangeExchange();
    }
    // 获取积分兑换列表
  }, {
    key: "getIntegralExchangeExchange",
    value: function () {
      var _getIntegralExchangeExchange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              anchor = readCookie('anchor');
              _context2.next = 3;
              return getIntegralExchange({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 3:
              res = _context2.sent;
              if (res.data && res.data.code === 100) {
                this.totalnumber = res.data.data.total;
                this.integralExchange = res.data.data.list ? res.data.data.list : [];
                this.integralExchange = this.integralExchange.map(function (item) {
                  var data = item;
                  if (data.lowest_price.split(',')[0]) {
                    // const lowPrice = data.lowest_price.split(',')[0].split('.')[0];
                    // const lowPrice2 = data.lowest_price.split(',')[0].split('.')[1];
                    // data.lowPrice = (lowPrice - data.discount_amount) >= 0 ? (lowPrice - data.discount_amount) : 0;
                    // data.lowPrice2 = lowPrice2;
                    var lowPrice = ((data.lowest_price.split(',')[0] || data.lowest_price) - data.discount_amount).toFixed(2).toString();
                    data.lowPrice = lowPrice.substring(0, lowPrice.indexOf('.'));
                    data.lowPrice2 = lowPrice.substring(lowPrice.indexOf('.') + 1, lowPrice.length);
                  }
                  return data;
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getIntegralExchangeExchange() {
        return _getIntegralExchangeExchange.apply(this, arguments);
      }
      return getIntegralExchangeExchange;
    }()
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([State('user')], default_1.prototype, "userInfo", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu,
    IntegralRule: IntegralRule
  }
})], default_1);
export default default_1;